export const KEY_ICONS = {
	CLEAR: "e5c9",
	ENTER: "e86c",
	SHUFFLE: "e933",
	CLUE: "f8ea",
};

export const ICONS = {
	CLOSE: "e5cd",
	INFO: "e88e",
	SETTINGS: "e8b8",
	SHARE: "e80d",
	STAR: "e838",
	STAR_OUTLINE: "e83a",
};

// Row height (px) of a cell in DatesPanel's picker (PickerColumn.js uses
// this directly for its scroll math; DatesPanel.vue exposes it to both
// DatesPanel.scss and PickerColumn.scss as the `--picker-item-height` CSS
// custom property — see DatesPanel.js's pickerItemHeightStyle — so this one
// constant is the single source of truth instead of a value duplicated
// across JS and two separate .scss files).
export const PICKER_ITEM_HEIGHT = 37;
